import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import scrollToElement from '@resources/js/ui/scroll-to-element'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'
import '@resources/js/analytics'

initSharedPromotion()

// Navigation scroll
const navItems = document.querySelectorAll('.js-nav-item')

navItems.forEach(item => {
    item.addEventListener('click', () => {
        const navTarget = document.querySelector(item.dataset.target);
        scrollToElement(navTarget, {top: 120})
    })
});

// map
inViewport("#mapbox", () => {
    const map = new MapView({ zoom: 12 })
    const mapHotelsStore = new MapHotelsStore()
    const data = mapHotelsStore.getData()
    map.addMarkers(data)
    map.fitByCoords(mapHotelsStore.getCoordinates())
})
